import { useQuery } from "@tanstack/react-query";
import { nonChanging30Mins } from "../../../../config/query.config";
import { APIService } from "../../../../utils/api.service";
import { useAppDispatch, useAppSelector } from "../../../store";
import { setOffers } from "../offers.slice";
import { Offer } from "../offers.types";

const api = new APIService();

export const useGetAllOffers = () => {
  const dispatch = useAppDispatch();
  const { customer } = useAppSelector((s) => s.customer);
  return useQuery(
    ["offers/getAll", customer?.id ?? "guest"],
    () =>
      api.get<Offer[]>({
        url: "offer",
        config: {
          headers: {
            Authorization: `Bearer ${customer?.token}`,
          },
        },
      }),
    {
      ...nonChanging30Mins,
      onSuccess: (offers) => {
        dispatch(setOffers(offers));
      },
    }
  );
};
